import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";

export interface IFileIdFilter {
    (fileName: string): string;
}
// declare module "angular" {
//     interface IFilterService {
//         (name: "fileId"): IFileIdFilter;
//     }
// }

/**
 * Takes file name and strips non alpha-numeric characters out to make it compatible with
 * HTML ids, for instance.
 */
@NgFilter({
    token: Token.FileIdFilter,
    dependencies: [
    ]
})
export class FileIdFilter {
    constructor() {
        return ((fileName: string) => {
            return fileName.replace(/[^A-Z0-9]/gi, "_");
        }) as IFileIdFilter as any;
    }
}
